'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IconWithBackground;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./IconWithBackground.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function IconWithBackground(_ref) {
  var className = _ref.className,
      bgColor = _ref.bgColor,
      icon = _ref.icon,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('cp-icon-with-background', className) },
    _react2.default.createElement(
      'div',
      { className: 'icon-holder', style: { backgroundColor: bgColor } },
      icon
    ),
    _react2.default.createElement(
      'span',
      { className: 'content-holder' },
      children
    )
  );
}

IconWithBackground.propTypes = {
  className: _react.PropTypes.string,
  bgColor: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.node,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/IconWithBackground/IconWithBackground.js
// module id = 1207
// module chunks = 1